import React, { ReactNode } from "react";
import "./modal.css";
import { AiOutlineClose } from "react-icons/ai";
import { SiMicrosoftexcel } from "react-icons/si";
interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  onExportExcel?: () => void;
}

export default function Modal(props: ModalType) {
  return (
    <>
      {props.isOpen && (
        <div className="modal-nce-overlay">
          <div className="modal-nce-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-nce-header">
              <h4 className="modal-nce-title">
                {props.title ?? "Título do Modal"}
              </h4>

              <div className="modal-nce-actions">
                {props.onExportExcel && (
                  <button
                    onClick={props.onExportExcel}
                    className="btn-excel"
                    title="Exportar NCE para Excel"
                  >
                    <SiMicrosoftexcel size={18} />
                  </button>
                )}

                <button
                  type="button"
                  className="btn-close"
                  onClick={props.toggle}
                  title="Fechar"
                >
                  <AiOutlineClose color="white" />
                </button>
              </div>
            </div>

            <div className="modal-nce-body">{props.children}</div>
          </div>
        </div>
      )}
    </>
  );
}
